import { type PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentUser } from '@/hooks';

import LoadingCover from '@/components/Layouts/Loading';
import { hasFeature } from '@/types/user';

interface RequireFeatureProps extends PropsWithChildren {
  feature: string;
  redirectPath?: string;
}

const RequireFeature = ({
  children,
  feature,
  redirectPath = '/m',
}: RequireFeatureProps) => {
  const { user, isUserLoading } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isUserLoading && user.id && !hasFeature(user, feature)) {
      navigate(redirectPath, { replace: true });
    }
  }, [feature, isUserLoading, navigate, redirectPath, user]);

  if (isUserLoading) {
    return <LoadingCover />;
  }

  return hasFeature(user, feature) ? children : null;
};

export default RequireFeature;
